(function () {
  const SELECTORS = {
    section: '[data-hc-product-data]',
    more: '[data-hc-product-data-more]',
    toggle: '[data-hc-product-data-toggle]',
    toggleText: '[data-hc-product-data-toggle-text]',
    config: '[data-hc-product-data-config]',
    boxSize: '[data-hc-product-box-size]',
  };

  const imperialLocales = ['LR', 'MM', 'US'];

  function roundTo(value, precision) {
    const multiplier = Math.pow(10, precision);
    return Math.round(value * multiplier) / multiplier;
  }

  function prettifyMeasurement(value) {
    return Math.max(roundTo(value, 2), 0.01);
  }

  function convertLengthToLocaleValue(valueInMm, countryCode) {
    if (imperialLocales.includes(countryCode)) {
      return {
        val: prettifyMeasurement(valueInMm / 25.4),
        unit: 'in',
      };
    }

    return {
      val: prettifyMeasurement(valueInMm / 10),
      unit: 'cm',
    };
  }

  function parseBoxSize(rawValue) {
    if (!rawValue) return null;

    try {
      const parsed = JSON.parse(rawValue);

      if (typeof parsed === 'string') {
        return JSON.parse(parsed);
      }

      return parsed;
    } catch {
      return null;
    }
  }

  function getConfig(section) {
    const fallback = {
      moreText: 'More details',
      lessText: 'Less details',
    };

    const configEl = section.querySelector(SELECTORS.config);

    if (!configEl) return fallback;

    try {
      return {
        ...fallback,
        ...JSON.parse(configEl.textContent || '{}'),
      };
    } catch {
      return fallback;
    }
  }

  function renderBoxSizes(root) {
    root.querySelectorAll(SELECTORS.boxSize).forEach((el) => {
      const boxSize = parseBoxSize(el.dataset.boxSize);
      const countryCode = el.dataset.countryCode || 'UA';

      if (!boxSize || boxSize.w == null || boxSize.h == null || boxSize.d == null) {
        el.textContent = '';
        return;
      }

      const width = convertLengthToLocaleValue(Number(boxSize.w), countryCode);
      const height = convertLengthToLocaleValue(Number(boxSize.h), countryCode);
      const depth = convertLengthToLocaleValue(Number(boxSize.d), countryCode);

      el.textContent = `${width.val}x${height.val}x${depth.val} ${width.unit}`;
    });
  }

  function handleToggleClick(event) {
    const toggle = event.target.closest(SELECTORS.toggle);

    if (!toggle) return;

    const section = toggle.closest(SELECTORS.section);
    if (!section) return;

    const more = section.querySelector(SELECTORS.more);
    const toggleText = section.querySelector(SELECTORS.toggleText);
    const config = getConfig(section);

    if (!more) return;

    event.preventDefault();
    event.stopPropagation();

    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    const nextOpen = !isOpen;

    toggle.setAttribute('aria-expanded', String(nextOpen));
    toggle.classList.toggle('is-active', nextOpen);

    more.hidden = !nextOpen;

    if (toggleText) {
      toggleText.textContent = nextOpen ? config.lessText : config.moreText;
    }
  }

  function init(root) {
    renderBoxSizes(root || document);
  }

  document.addEventListener('click', handleToggleClick, true);

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        init(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();